<template>
  <div>
    <div class="bg-white shadow p-2 mb-3">
      <div class="row">
        <div class="col">
          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-center">Group By</label>
            <div class="col-sm-8">
              <v-select v-model="filter.groupBy" :options="['supplier', 'belanja']" />
            </div>
          </div>
        </div>
        <div class="col">
<!-- 
          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-center">Barang</label>
            <div class="col-sm-8">
              <input
                class="form-control form-control-sm"
                v-model.lazy="search"
                placeholder="Cari Barang"
                @keyup.enter="onRefresh" />
            </div>
          </div>
 -->
        </div>
      </div>

      <div class="row mt-2">
        <div class="col">
          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-center">Tanggal Awal</label>
            <div class="col-sm-8">
              <b-form-datepicker v-model="filter.startDate" locale="id" size="sm" />
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-center">Tanggal akhir</label>
            <div class="col-sm-8">
              <b-form-datepicker v-model="filter.endDate" locale="id" size="sm" />
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col">
          <button class="btn btn-sm btn-primary btn-icon-split" @click="onRefresh" :disabled="isLoading">
            <span class="icon"><i class="fas fa-search" /></span>
            <span class="text">Cari <b-spinner small v-show="isLoading" /></span>
          </button>
        </div>

        <div class="col text-right">
          <button class="btn btn-sm btn-info btn-icon-split text-dark mr-2" @click="onPrint" :disabled="isLoading">
            <span class="icon"><i class="fas fa-print" /></span>
            <span class="text">Cetak <b-spinner small v-show="isLoading" /></span>
          </button>

          <button class="btn btn-sm btn-success btn-icon-split text-dark" @click="onRefresh" :disabled="isLoading">
            <span class="icon"><i class="fas fa-file-excel" /></span>
            <span class="text">Export Excel <b-spinner small v-show="isLoading" /></span>
          </button>
        </div>
      </div>
    </div>

    <AppTable
      :apiUrl="apiUrl"
      :fields="tableFields"
      :filter="filter"
      :search="search"
      @onSelectItem="selectedItem = $event" />

    <b-modal id="modalPrint" hide-footer no-close-on-backdrop title="Cetak" size="lg" header-class="bg-light text-primary py-1">
      <iframe ref="printFrame" id="printFrame" class="w-100" height="600" name="printFrame"></iframe>
      <div class="text-center">
        <button class="btn btn-primary" @click="printToPDF">Print</button>
      </div>
    </b-modal>

  </div>
</template>

<script>
const CURRENT_YEAR = (new Date()).getFullYear()
const CURRENT_MONTH = (new Date()).getMonth()

import AppTable from '@/components/app/AppTable.vue'

export default {
  components: { AppTable },
  mounted() {
    this.loadOptionData()
  },
  data() {
    return {
      apiUrl: '/report-incoming-item',
      tableFields: [
        { key: 'index', label: 'No.' },
        { key: 'SupplierName', label: 'Nama Supplier' },
        { key: 'Category', label: 'Belanja' },
        { key: 'InvoiceDate', label: 'Tgl Faktur', formatter: value => this.$helper.formatDate(value) },
        { key: 'InvoiceCode', label: 'No. Faktur' },
        { key: 'Total', label: 'Jumlah', formatter: value => this.$helper.formatRupiah(value) }
      ],
      selectedItem: null,
      search: '',
      listItem: [],
      listSupplier: [],
      filter: {
        groupBy: 'supplier',
        startDate: (new Date(CURRENT_YEAR, CURRENT_MONTH, 1)).toISOString().slice(0,10),
        endDate: (new Date(CURRENT_YEAR, CURRENT_MONTH + 1, 0)).toISOString().slice(0,10)
      }
    }
  },
  computed: {
    isLoading () {
      return this.$store.state.isLoading
    }
  },
  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    },
    loadOptionData () {
      this.$axios.all([
        this.$axios.get('/logistic-supplier')
      ]).then(this.$axios.spread((...res) => {
        this.listSupplier = res[0].data
      }))
    },
    onPrint () {
      this.$bvModal.show('modalPrint')

      const params = this.filter

      this.$axios.get('/report-incoming-item', { params }).then(res => {

        const head = `
          <h2 class="text-center">RSUD dr. Soegiri Lamongan</h2>
          <h2 class="text-center">DAFTAR BARANG MASUK</h2>
          <h4 class="text-center">Periode tanggal ${this.$helper.formatDate(this.filter.startDate)} s.d. ${this.$helper.formatDate(this.filter.endDate)}</h4>

          <table border="1">
          <tr>
            <th>No.</th>
            <th>Nama Supplier</th>
            <th>Belanja</th>
            <th>No. Faktur</th>
            <th>Tgl Faktur</th>
            <th>Jumlah</th>
          </tr>
        `

        let content = ''
        let grandTotal = 0

        for (var i = 0; i < res.data.length; i++) {
          content += `
            <tr>
              <td>${i+1}</td>
              <td>${res.data[i].SupplierName}</td>
              <td>${res.data[i].Category}</td>
              <td>${res.data[i].InvoiceCode}</td>
              <td>${this.$helper.formatDate(res.data[i].InvoiceDate)}</td>
              <td nowrap>${this.$helper.formatRupiah(res.data[i].Total)}</td>
            </tr>
          `

          grandTotal += res.data[i].Total
        }

        content += `
          <tr style="font-weight: bold;">
            <td colspan="5" style="text-align: right;">Grand Total</td>
            <td nowrap>${this.$helper.formatRupiah(grandTotal)}</td>
          </tr>
        `

        this.$nextTick(function () {

          const html = this.$constant.TEMPLATE_PRINT_HEADER
            + head
            + content
            + this.$constant.TEMPLATE_PRINT_FOOTER

          this.$refs.printFrame.srcdoc = html
        })
      })
    },
    printToPDF () {
      window.frames['printFrame'].print()
    }
  }
}
</script>
